import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div>
            <footer className='footer text-center py-4'>
                <h4 className='text-white'>
                    2022 @ Giovanna
                </h4>

            </footer>
        </div >
    )
}

export default Footer;

